<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M70.5079 57.4452H67.5842C66.3352 57.4452 66.2873 59.1396 66.2563 60.3435C66.2393 60.9892 66.7666 61.5192 67.4122 61.5192H68.0832C68.7232 61.5192 69.2392 61.0004 69.2392 60.3633C69.2392 59.7233 69.7579 59.2073 70.3951 59.2073H71.8415C71.3875 58.6265 70.9562 58.0288 70.5079 57.4452Z"
            class="primary-fill" />
        <path
            d="M78.4436 57.4452H75.4805C75.768 58.0147 75.9513 58.6322 76.1148 59.2665C76.5744 59.4188 76.9071 59.853 76.9071 60.3633C76.9071 61.0033 77.4258 61.5192 78.063 61.5192H78.7256C79.3346 61.5192 79.8364 61.0512 79.8787 60.4422C79.9633 59.2355 80.0451 57.4424 78.4408 57.4424L78.4436 57.4452Z"
            class="primary-fill" />
        <path
            d="M54.7558 12.1404C52.9796 11.8303 52.0041 11.9121 50.9186 12.2278C49.8332 12.5436 48.8238 13.2428 48.3361 14.2606C48.1726 14.6017 48.0682 14.9683 47.885 15.2981C47.4875 16.0058 46.7572 16.4654 46.2779 17.1195C45.3786 18.3431 45.4885 20.0065 45.6379 21.5177C45.6633 21.7743 45.7225 22.0787 45.9819 22.1577C46.1201 22.2 46.2723 22.1521 46.3823 22.059C46.5768 21.8927 46.6388 21.6417 46.698 21.4049C47.0138 20.17 47.4536 18.9661 48.0119 17.8215C48.1444 17.548 48.3586 17.235 48.6603 17.2717C48.7815 17.2858 48.8887 17.3563 48.9874 17.4296C49.3821 17.72 49.7345 18.0639 50.039 18.4502C50.4112 18.9239 50.7044 19.4595 51.0822 19.9304C51.46 20.4012 51.9477 20.8213 52.5398 20.9425C53.2587 21.092 54.0087 20.7875 54.7333 21.0102C54.987 21.0891 55.2126 21.247 55.3564 21.4726C55.6467 21.9293 55.4099 22.2705 55.2351 22.6172C55.1393 22.8061 55.0603 23.0007 54.9983 23.2037C54.9053 23.511 55.2295 23.7732 55.5171 23.6266C55.8272 23.4687 56.1599 23.3531 56.501 23.2854C56.8563 23.215 57.2284 23.1896 57.5498 23.0204C57.9953 22.7836 58.2575 22.3015 58.4069 21.8222C58.7058 20.8551 58.6466 19.8035 58.4041 18.8224C58.1616 17.8412 57.7444 16.908 57.3299 15.9861C58.1278 16.034 58.9652 16.0706 59.6841 15.7182C60.7301 15.2051 61.246 13.9561 61.2348 12.7917C61.2291 12.2955 61.1417 11.7936 60.9049 11.3595C60.5609 10.7223 59.9294 10.2824 59.2527 10.0259C58.5761 9.76932 57.8515 9.6791 57.1326 9.59452C56.8591 9.56069 56.58 9.52967 56.3121 9.59452C55.6749 9.7524 55.2971 10.4065 55.097 11.0324C54.8319 11.8557 54.7474 12.7353 54.846 13.5952"
            class="primary-fill" />
        <path
            d="M46.7461 20.8522C46.2922 24.9826 48.652 27.8612 50.6961 27.9175C50.744 27.9175 50.792 27.9175 50.8399 27.9175C52.8191 27.8442 54.2936 25.1799 54.3585 25.0643"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M55.1948 23.5928C55.1948 23.5928 55.2512 26.649 56.0012 28.2927C56.7511 29.9364 57.0979 31.1769 54.2701 31.8113C51.4451 32.4456 51.0419 31.7239 50.8953 30.0238C50.8953 30.0238 46.311 30.6018 44.8674 34.7519C43.4267 38.9048 41.8112 45.5952 41.8112 45.5952L33.1022 42.4798L30.6211 43.1706C30.6211 43.1706 31.0835 46.3988 35.1208 48.4174C39.1582 50.4361 45.3298 53.3204 46.3674 47.7267"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M56.6074 29.4174C56.6074 29.4174 63.6531 28.0416 66.1144 35.0788C68.5757 42.1159 68.9591 45.0368 72.6131 51.8795C76.2642 58.7221 77.1495 61.0312 77.1495 61.0312C77.1495 61.0312 80.1859 62.1082 80.6088 63.1062C81.0317 64.1071 80.1098 65.5676 80.1098 65.5676C80.1098 65.5676 77.6118 63.8365 75.8046 62.7228C73.9974 61.6092 73.8818 61.4936 72.4975 59.8781C71.1132 58.2625 68.3445 53.495 66.1933 48.344C64.0393 43.1929 62.9651 38.9639 62.9651 38.9639"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M37.4355 111.149C39.739 99.9192 40.4072 98.487 41.4701 94.6131C42.4512 91.0382 43.2576 89.2507 45.1607 84.8665C47.8447 78.6836 48.5467 71.8974 50.2102 65.3649"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M43.5 111.786C48.7497 104.275 52.6235 95.8028 54.8734 86.9189C55.1384 85.8701 55.3837 84.8072 55.8545 83.8317C56.2267 83.0592 56.7314 82.3628 57.2304 81.6664C61.4059 75.8303 65.4433 69.5628 66.4752 62.4636L66.8078 58.9957"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M37.4785 111.101C39.297 111.532 41.1465 111.822 43.0101 111.972"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M39.9311 93.8265C38.5045 89.7214 37.3682 86.2592 37.6756 81.923C37.8673 79.2446 38.699 76.6564 39.6576 74.1472C41.4479 69.4754 43.7006 64.9954 45.9504 60.5267C45.9504 60.5267 46.9654 58.5672 46.6976 55.9537C46.4297 53.3401 46.8047 51.4342 46.8047 51.4342"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M38.0379 111.338C37.9223 111.394 37.3754 112.722 35.9037 114.106C34.432 115.491 32.058 114.684 30.7132 116.7C30.0788 117.653 30.4538 117.738 30.4538 117.738H41.4409C41.4409 117.738 42.5067 116.094 41.269 114.882C40.0313 113.669 41.2408 111.825 41.2408 111.825L38.0408 111.335L38.0379 111.338Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M46.3696 110.762C46.3978 110.878 46.8489 114.357 46.3893 115.279C45.9298 116.201 45.3038 116.77 44.5257 116.875C43.46 117.019 43.5446 118.172 43.5446 118.172L48.2163 118.259C48.2163 118.259 49.1664 117.938 49.3976 115.865C49.5809 114.241 51.1851 113.906 51.4163 112.837C51.7997 111.058 49.8882 109.127 49.8882 109.127L46.3696 110.762Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M45.1895 109.319L45.9394 111.453L50.208 109.494C50.208 109.494 49.6892 103.581 49.5454 102.313"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M60.7461 30.0179C61.1803 34.0158 61.6145 38.0137 62.0486 42.0116C62.3419 44.7013 62.6323 47.3938 63.1736 50.044C63.5288 51.7779 63.9912 53.4978 64.6989 55.1189C64.9188 55.6236 65.181 56.1395 65.6321 56.4553C66.0832 56.7711 66.7739 56.8134 67.1405 56.4017"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M67.1914 56.2636C67.3577 54.7778 67.307 53.4386 67.2478 50.9011"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M49.5918 30.5368C49.8427 33.2942 49.7666 36.0741 49.9499 38.8371C50.1331 41.6001 50.5955 44.4025 51.8332 46.8159C52.1292 47.3939 52.476 47.955 52.961 48.3525C53.4459 48.75 54.0859 48.9559 54.6639 48.7641C55.146 48.6034 55.521 48.1918 55.8396 47.7633C57.8639 45.0425 58.2473 41.3012 58.3657 37.7883C58.4559 35.1211 58.439 32.4512 58.3178 29.7869"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M47.7952 31.2869C48.5226 37.9998 48.1871 44.8284 46.8027 51.437"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M30.5816 43.1366C30.4773 42.288 29.8598 41.6029 29.5497 40.805C29.1212 39.7054 29.3072 38.4734 29.499 37.309C29.7048 36.0515 29.9134 34.7941 30.1192 33.5366C30.3758 33.6015 30.4829 33.9031 30.5252 34.1653C30.5675 34.4275 30.607 34.7236 30.8241 34.8758C30.9679 34.9773 31.1652 34.9858 31.3034 35.0986C31.5402 35.2959 31.4669 35.6681 31.4049 35.9726C31.3428 36.2771 31.3823 36.6887 31.684 36.7592C31.777 36.7817 31.8785 36.7648 31.9631 36.8099C32.09 36.8776 32.1097 37.0439 32.1125 37.1877C32.1266 37.8616 32.0674 38.5354 31.9321 39.1951C31.9095 39.2994 31.8954 39.4291 31.9772 39.4968C32.0223 39.5334 32.0815 39.5391 32.1407 39.5447C32.4988 39.5701 32.8597 39.556 33.2149 39.4968"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M33.2675 39.4967C33.1321 40.2523 33.0617 41.2504 33.1632 42.0116C33.1773 42.1131 33.1914 42.2259 33.1378 42.3133C33.087 42.4007 32.9884 42.4401 32.8953 42.4768C32.2694 42.7221 32.1059 42.7446 31.0684 42.9899"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M30.5645 34.109C30.5109 33.7792 30.7365 33.469 31.0664 33.4154L33.601 33.0095C33.9309 32.9559 34.241 33.1814 34.2946 33.5113L35.1206 38.6454C35.1742 38.9753 34.9487 39.2854 34.6188 39.339L32.0842 39.745"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M70.4544 61.1693H66.6934"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M73.3789 60.6084L75.1072 59.8556"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M85.4265 50.6079C87.854 49.1672 89.6359 46.9991 90.7692 44.1036C91.9026 41.208 92.1141 38.2364 91.4064 35.1859L89.743 28.0387L79.8751 26.7474L71.5918 32.2621L73.2552 39.4093C73.9657 42.4599 75.4656 45.034 77.7606 47.1288C80.0556 49.2264 82.6099 50.3851 85.4265 50.6079Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M76.5273 36.7648L82.8963 41.1292L94.797 26.6996"
            class="accent-stroke"
            stroke-width="5.63877"
            stroke-linejoin="round" />
        <path
            d="M72.7871 20.7589V21.8726"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M72.7871 23.9308V25.0416"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M70.6484 22.9016H71.7593"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M73.8203 22.9016H74.9312"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M96.5723 38.7944V39.9053"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M96.5723 41.9663V43.0771"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M94.4297 40.9343H95.5405"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M97.6016 40.9343H98.7124"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M70.9012 114.033H85.1419C88.793 114.033 91.7534 111.072 91.7534 107.421V68.1586C88.17 83.4143 83.9211 103.043 81.1581 103.136C78.2514 103.235 82.6411 68.029 79.0718 67.4059C78.1781 67.2508 76.8417 69.199 74.9583 74.1301C68.0818 92.1262 65.5811 104.19 64.4956 104.111C63.7005 104.052 63.1677 104.672 63.8951 78.0744"
            class="accent-stroke"
            stroke-width="5.63877"
            stroke-linejoin="round" />
        <path
            d="M54.9629 86.868V106.677C54.9629 110.751 58.2644 114.053 62.3384 114.053H67.5204"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M77.3633 61.1073H84.1524C88.2264 61.1073 91.5279 64.4088 91.5279 68.4828"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M55.3496 108.704H58.5411C61.3436 108.704 63.616 110.977 63.616 113.779"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M91.0262 108.704H87.8347C85.0322 108.704 82.7598 110.977 82.7598 113.779"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M65.2623 118.454C66.4255 118.454 67.3684 117.511 67.3684 116.348C67.3684 115.185 66.4255 114.242 65.2623 114.242C64.0992 114.242 63.1562 115.185 63.1562 116.348C63.1562 117.511 64.0992 118.454 65.2623 118.454Z"
            class="primary-fill" />
        <path
            d="M80.7838 118.454C81.947 118.454 82.8899 117.511 82.8899 116.348C82.8899 115.185 81.947 114.242 80.7838 114.242C79.6207 114.242 78.6777 115.185 78.6777 116.348C78.6777 117.511 79.6207 118.454 80.7838 118.454Z"
            class="primary-fill" />
    </svg>
</template>
